import { ReactNode } from 'react';

import { Tooltip } from '@iwoca/orion';
import { CardCvcElement } from '@stripe/react-stripe-js';
import { StripeCardCvcElementChangeEvent } from '@stripe/stripe-js';
import { FormattedMessage, useIntl } from 'react-intl';

import { DebitCardFieldWrapper } from '../../DebitCardFieldWrapper';
import { stripeElementStyles } from '../../ElementStyles';

export const CVVField = ({
    error,
    onFocus,
    onBlur,
    onChange,
    className,
    placeholder,
    label
}: {
    error: boolean | null;
    onFocus?: () => void;
    onBlur?: () => void;
    onChange: (field: StripeCardCvcElementChangeEvent) => void;
    className?: string;
    placeholder?: string;
    label?: ReactNode;
}) => {
    const intl = useIntl();

    const errorMessage = intl.formatMessage({
        id: '_.link_debit_card.cvv_error',
        defaultMessage: 'Invalid CVC'
    });

    return (
        <DebitCardFieldWrapper
            label={
                <>
                    {label ?? (
                        <FormattedMessage
                            id="_.link_debit_card.cvv"
                            defaultMessage="CVC"
                        />
                    )}
                    <Tooltip
                        dataTestId="cvvHelpTooltip"
                        placement="top"
                        content={intl.formatMessage({
                            id: '_.link_debit_card.cvv_number_tooltip',
                            defaultMessage:
                                'The 3 digit number on the back of your card'
                        })}
                    />
                </>
            }
            error={error ? errorMessage : null}
            className={className}
        >
            <CardCvcElement
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                options={{ style: stripeElementStyles, placeholder }}
            />
        </DebitCardFieldWrapper>
    );
};
